'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _availability = require('availability');

var _Restaurant = require('../Restaurant');

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _FutureDeliveryHelper = require('./FutureDeliveryHelper');

var _FutureDeliveryHelper2 = _interopRequireDefault(_FutureDeliveryHelper);

var _DeliveryMethodsHelper = require('./DeliveryMethodsHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Availability = function () {
    function Availability() {
        var _moment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _momentTimezone2.default;

        (0, _classCallCheck3.default)(this, Availability);

        this.moment = _moment;
    }

    (0, _createClass3.default)(Availability, [{
        key: 'canOrderAsap',
        value: function canOrderAsap(_ref) {
            var organization = _ref.organization;

            if (_lodash2.default.get(organization, 'orders.asap.disabled')) return false;

            var _Restaurant$getDelive = _Restaurant2.default.getDeliveryOptions({
                restaurant: organization,
                cal: this.moment()
            }),
                hasTakeout = _Restaurant$getDelive.hasTakeout,
                hasDelivery = _Restaurant$getDelive.hasDelivery,
                takeout = _Restaurant$getDelive.takeout,
                delivery = _Restaurant$getDelive.delivery;

            return hasTakeout && (takeout.available || takeout.preorder) || hasDelivery && (delivery.available || delivery.preorder);
        }
    }, {
        key: 'canOrderSpecificTime',
        value: function canOrderSpecificTime(_ref2) {
            var cart = _ref2.cart,
                organization = _ref2.organization;

            var deliveryType = cart.delivery.type;
            return _FutureDeliveryHelper2.default.isFutureOrdersActivated(organization) && (0, _DeliveryMethodsHelper.canPotentiallySelectDeliveryTypeNow)(deliveryType, organization, this.moment);
        }
    }, {
        key: 'getFirstAvailabilityStartTime',
        value: function getFirstAvailabilityStartTime(availability, from) {
            var timestamp = (0, _availability.getEarliestAvailableTime)(availability, from);
            return (0, _momentTimezone2.default)(timestamp);
        }
    }]);
    return Availability;
}();

exports.default = Availability;